import { string as yupString } from "yup";

export const validateEmail = (email: string): boolean =>
  yupString().email().required().isValidSync(email.trim());
